import { render, staticRenderFns } from "./TicketOrders.vue?vue&type=template&id=6c1868a4&scoped=true&"
import script from "./TicketOrders.vue?vue&type=script&lang=js&"
export * from "./TicketOrders.vue?vue&type=script&lang=js&"
import style0 from "./TicketOrders.vue?vue&type=style&index=0&id=6c1868a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1868a4",
  null
  
)

export default component.exports